<template>
  <div id="component-file-upload" class="container-fluid">
    <div class="d-none">
      <label>Files<input id="files" ref="files" data-multiple-caption="{count} files selected" multiple name=files[]
                         type="file" v-on:change="handleFilesUpload()"/></label>
    </div>

    <template v-if="files.length > 0">
      <button class="btn btn-info btn-sm float-right mb-2" type="button" v-on:click="addFiles()">
        <i class="mdi mdi-upload-outline"></i>
      </button>

      <div class="table-responsive">
        <table class="table table-centered table-nowrap mb-0">
          <thead class="thead-light">
          <tr>
            <th class="border-0">Nome</th>
            <th class="border-0">Tamanho</th>
            <th class="border-0">Status</th>
            <th class="border-0">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(file, key) in files" :key="key + '_file'">
            <td class="border-0">
              <!--                            <img src="" :alt="file.name" :id="key + '_file'" class="rounded avatar-lg"/>-->
              {{ file.name }}
            </td>
            <td class="border-0">
              {{ formatBytes(file.size) }}
            </td>
            <td class="border-0">
              {{ getStatus(file.status) }}
            </td>
            <td class="border-0">
              <a
                  class="btn btn-danger btn-sm"
                  href="javascript:void(0)"
                  v-on:click="removeFile(key)"
                  title="Excluir"
              >
                <i class="mdi mdi-trash-can-outline"></i>
              </a>
              <a
                  class="btn btn-primary btn-sm"
                  href="javascript:void(0)"
                  v-on:click="toggleStatus(file, key)"
                  title="Alterar status"
              >
                <i class="mdi mdi-pencil-outline"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-else>
      <div id="drop_zone"
           ref="dropZone"
           class="box px-0"
           @click="addFiles"
           @dragend="addClassDrop"
           @dragenter="dragOverHandler"
           @dragleave="addClassDrop"
           @dragover="dragOverHandler"
           @drop="dropHandler"
      >

        <p class="pt-1">
          <span class="text-muted text-center font-22">
              <i class="mdi mdi-cloud-upload mr-2"></i>
              Mova um ou mais arquivos
          </span>
          <span class="text-muted text-center font-22">
              para fazer upload
          </span>
        </p>
      </div>
    </template>

    <!-- make html modal with buttons and respected icons for pending, approved and rejected status -->
    <div class="modal fade" id="statusModal" tabindex="-1" role="dialog">

      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Alteração de status da imagem
            </h4>

            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>

          <div class="modal-body" v-if="selectedFile">
            <div class="row">
              <div class="col-12">
                <div class="form-group col-12">
                  <label for="select-status">
                    Status
                  </label>
                  <select
                      class="form-control"
                      id="select-status"
                      name="status"
                      v-model="selectedFile.status"
                  >
                    <option value="pending">Pendente</option>
                    <option value="approved">Aprovado</option>
                    <option value="rejected">Rejeitado</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
            >
              Cancelar
            </button>

            <button
                type="button"
                class="btn btn-primary"
                @click="updateStatus"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileUpload",

  data() {
    return {
      files: [],
      selectedFile: null,
    }
  },

  mounted() {
  },

  methods: {
    addFiles() {
      this.$refs.files.click();
    },

    async handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;

      uploadedFiles.forEach((file, index) => {
        file.status = 'approved';
        this.files.push(file);

        // setTimeout(() => {
        //     this.previewImage(file, this.files.length-1)
        // }, 100);
      })
    },

    async removeFile(key) {
      let file = this.files[key];

      if (file.hasOwnProperty('id')) {
        console.debug(file.id)
        try {
          const message = await alertConfirm({
            url: route('api.ecommerce.product.destroyFile', file.id)
          })

          if (message === 'confirm') {
            this.files.splice(key, 1);
          }
        } catch (e) {
          console.error(e)
        }
      } else {
        this.files.splice(key, 1);
      }
    },

    previewImage(file, index) {
      const preview = document.getElementById(`${index}_file`);
      const reader = new FileReader();

      reader.addEventListener("load", function () {
        // convert image file to base64 string
        preview.src = reader.result;
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    },

    bytesToMegaBytes(bytes, roundTo) {
      var converted = bytes / (1024 * 1024);
      return roundTo ? converted.toFixed(roundTo) : converted;
    },

    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    addClassDrop(event) {
      event.preventDefault();

      let element = this.$refs['dropZone'];

      if (element.classList.contains('is-dragover')) {
        element.classList.remove('is-dragover')
      }
    },

    dropHandler(ev) {

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();

      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < ev.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === 'file') {
            let file = ev.dataTransfer.items[i].getAsFile();
            if (file) {
              file.status = 'approved';
              this.files.push(file);

              // setTimeout(() => {
              //     this.previewImage(file, i)
              // }, 300);
            }

          }
        }
      }
    },

    dragOverHandler(ev) {
      let element = this.$refs['dropZone'];

      if (!element.classList.contains('is-dragover')) {
        element.classList.add('is-dragover')
      }

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();
    },
    getStatus(status) {
      switch (status) {
        case 'waiting':
          return 'Aguardando';
        case 'uploading':
          return 'Enviando';
        case 'success':
          return 'Sucesso';
        case 'error':
          return 'Erro';
        case 'approved':
          return 'Aprovado';
        case 'pending':
          return 'Pendente de aprovação';
        case 'rejected':
          return 'Rejeitado';
        default:
          return 'Aguardando';
      }
    },
    toggleStatus(file, key) {
      this.selectedFile = file;
      $('#statusModal').modal('show');

      // const newStatus = file.status === 'pending' ? 'approved' : 'pending';
      // const labelNewStatus = this.getStatus(newStatus);
      // alertConfirm({
      //   message: 'Tem certeza que deseja alterar o status do arquivo para ' + labelNewStatus + '?',
      //   confirmButtonText: 'Confirmar',
      //   messageOnCancel: 'Ufaaa! Não alteramos nada.',
      //   cbOnSuccess: () => {
      //     if (file.hasOwnProperty('id')) {
      //       axios.post(route('api.ecommerce.product.updateFileStatus', file.id), {
      //         status: newStatus
      //       }).then(() => {
      //         this.files[key].status = newStatus;
      //       })
      //     } else {
      //       this.files[key].status = newStatus;
      //     }
      //   }
      // })
    },
    updateStatus() {
      if (!this.selectedFile) {
        $('#statusModal').modal('hide');

        toastError('Selecione um arquivo para alterar o status');
        return;
      }

      const key = this.files.indexOf(this.selectedFile);
      const newStatus = this.selectedFile.status;

      axios.post(route('api.ecommerce.product.updateFileStatus', this.selectedFile.id), {
        status: this.selectedFile.status
      }).then(() => {
        this.files[key].status = newStatus;

        $('#statusModal').modal('hide');
      })
    }
  }
}
</script>

<style lang="scss">
$stripes-color: #F6F6F6;

@keyframes stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 60px 30px;
  }
}

#component-file-upload {
  .box {
    min-height: 100px;
    min-width: 100px;
    border: dotted 3px #999;
    margin-left: 0;
    margin-right: 0;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:hover {
      background-size: 30px 30px;
      background-image: linear-gradient(
              -45deg,
              $stripes-color 25%,
              transparent 25%,
              transparent 50%,
              $stripes-color 50%,
              $stripes-color 75%,
              transparent 75%,
              transparent
      );
      animation: stripes 3s linear infinite;
    }
  }
}
</style>
